"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var app = {
    LOCAL_STORAGE: {
        TELEMATICS: {
            AUTH_STATE: 'Telematics.STATE',
            CUSTOM_TAGS: 'Telematics.CustomTags.:tan',
            NONCE: 'Telematics.NONCE',
            REFRESH_INFO: 'Telematics.refresh.TOKEN_INFO',
            TAN: 'Telematics.TAN',
            TOKEN: 'Telematics.TOKEN',
            USER_AUTH_INFO: 'Telematics.user.auth.INFO',
            USER_TOKEN: 'Telematics.USER',
            VT_REGISTRATION_EMAIL: 'Telematics.vt.registration.email',
        },
        HEREMAP: {
            ACCESS_TOKEN: 'access_token',
            ACCESS_TOKEN_EXPIRATION: 'access_token_expiration',
        },
    },
};
exports.default = app;
